import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import Tippy from "@tippyjs/react";
import classNames from "classnames";
import React from "react";
var Tooltip = function(_param) {
    var children = _param.children, className = _param.className, content = _param.content, others = _object_without_properties(_param, [
        "children",
        "className",
        "content"
    ]);
    return /*#__PURE__*/ _jsx(Tippy, _object_spread_props(_object_spread({
        arrow: true,
        interactive: true,
        hideOnClick: "toggle",
        content: /*#__PURE__*/ _jsx("div", {
            className: classNames("text-default text-left p-4 max-w-xs leading-snug rounded-lg text-xs whitespace-no-wrap bg-tertiary more-shadow", className),
            children: content
        })
    }, others), {
        children: /*#__PURE__*/ _jsx("div", {
            children: children
        })
    }));
};
export default Tooltip;
